import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { XCircleIcon } from 'lucide-react';
export function SolutionsFailSection() {
  return <section id="solutions" className="py-10 md:py-32 bg-charcoal" data-id="element-290">
      <div className="max-w-4xl mx-auto px-6" data-id="element-291">
        <FadeIn data-id="element-292">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-sand mb-8 md:mb-12 text-center" data-id="element-293">
            Por qué las soluciones habituales fallan
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-294">
          <FadeIn direction="right" data-id="element-295">
            <div className="space-y-6 text-lg text-offwhite-dim" data-id="element-296">
              <p data-id="element-297">
                Probaste cosas. Muchas. Dietas. Planes de entrenamiento. Apps de
                meditación. Libros de hábitos. Podcasts de desarrollo personal.
              </p>
              <p data-id="element-298">Y funcionan… un tiempo.</p>
              <p className="font-medium text-offwhite" data-id="element-299">
                El problema no es que sean malos. El problema es que atacan{' '}
                <span className="text-amber" data-id="element-300">una sola parte</span>.
              </p>
            </div>
          </FadeIn>

          <FadeIn direction="left" delay={0.2} data-id="element-301">
            <ul className="space-y-4" data-id="element-302">
              {['El plan de entrenamiento trabaja el cuerpo, pero no toca lo que pasa adentro cuando fallás 2 días seguidos.', 'La meditación calma la mente, pero no regula el sistema nervioso si tu comida, tu sueño y tus pantallas siguen desregulados.', "El libro de hábitos te da el 'qué', pero no te sostiene cuando el entorno tira para el otro lado."].map((item, i) => <li key={i} className="flex items-start space-x-4 bg-charcoal-dark p-4 rounded-sm border border-charcoal-light" data-id="element-303">
                  <XCircleIcon className="w-6 h-6 text-amber shrink-0 mt-0.5" data-id="element-304" />
                  <span className="text-offwhite-dim text-sm md:text-base" data-id="element-305">
                    {item}
                  </span>
                </li>)}
            </ul>
          </FadeIn>
        </div>

        <FadeIn delay={0.4} className="mt-10 md:mt-16 text-center max-w-3xl mx-auto" data-id="element-306">
          <h3 className="text-2xl font-heading font-bold text-offwhite mb-6" data-id="element-307">
            Ninguno trabaja el cuerpo y el alma al mismo tiempo.
          </h3>
          <p className="text-lg text-offwhite-dim mb-8" data-id="element-308">
            Y ahí está el problema real. Porque vos no sos solo un cuerpo que
            hay que entrenar. No sos solo una mente que hay que calmar. Sos los
            dos. Siempre. Al mismo tiempo.
          </p>

          <div className="bg-charcoal-dark border border-charcoal-light p-8 rounded-sm" data-id="element-309">
            <div className="space-y-4 text-left md:text-center font-medium text-offwhite-dim" data-id="element-310">
              <p data-id="element-311">
                Cuerpo desregulado ={' '}
                <span className="text-amber" data-id="element-312">mente ruidosa.</span>
              </p>
              <p data-id="element-313">
                Mente ruidosa ={' '}
                <span className="text-amber" data-id="element-314">decisiones desde el miedo.</span>
              </p>
              <p data-id="element-315">
                Decisiones desde el miedo ={' '}
                <span className="text-amber" data-id="element-316">vida que no fluye.</span>
              </p>
            </div>
            <div className="mt-8 pt-8 border-t border-charcoal-light" data-id="element-317">
              <p className="text-xl font-heading font-bold text-sand" data-id="element-318">
                El único camino de vuelta es trabajar los dos juntos.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}